import {
  createPlugin,
  createRoutableExtension,
  createApiFactory,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import { rootRouteRef } from './routes';
import { platformStudioApiRef } from './api/PlatformStudioApi';
import { PlatformStudioClient } from './api/PlatformStudioClient';

export const platformStudioPlugin = createPlugin({
  id: 'platform-studio',
  routes: {
    root: rootRouteRef,
  },
  apis: [
    createApiFactory({
      api: platformStudioApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, fetchApi }) =>
        new PlatformStudioClient({ discoveryApi, fetchApi }),
    }),
  ],
});

export const PlatformStudioPage = platformStudioPlugin.provide(
  createRoutableExtension({
    name: 'PlatformStudioPage',
    component: () =>
      import('./components/PlatformStudioPage').then(
        m => m.PlatformStudioPage,
      ),
    mountPoint: rootRouteRef,
  }),
);
